"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var tubular_common_1 = require("tubular-common");
var id = 0;
exports.tbId = function () {
    return "tbComponent_" + id++;
};
exports.getLocalDataSource = function (source) { return function (request) {
    return new Promise(function (resolve, reject) {
        try {
            resolve(tubular_common_1.default.getResponse(request, source));
        }
        catch (error) {
            reject(error);
        }
    });
}; };
exports.getRemoteDataSource = function (request) { return function (gridRequest) { return __awaiter(void 0, void 0, void 0, function () {
    var httpCast, httpClient, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                httpCast = request;
                httpClient = httpCast.request ? httpCast : new tubular_common_1.TubularHttpClient(request);
                return [4 /*yield*/, httpClient.fetch(gridRequest)];
            case 1:
                data = _a.sent();
                if (!tubular_common_1.TubularHttpClient.isValidResponse(data)) {
                    throw new Error('Server response is a invalid Tubular object');
                }
                tubular_common_1.TubularHttpClient.fixResponse(data);
                data.payload = data.payload.map(function (row) { return tubular_common_1.parsePayload(row, gridRequest.columns); });
                return [2 /*return*/, data];
        }
    });
}); }; };
exports.generateOnRowClickProxy = function (onRowClick) {
    return function (row) { return function () {
        if (onRowClick) {
            onRowClick(row);
        }
    }; };
};
function printDoc(gridResult, columns, gridName) {
    var tableHtml = tubular_common_1.getHtml(gridResult, columns);
    var documentToPrint = window.open('about:blank', 'Print', 'location=0,height=500,width=800');
    documentToPrint.document.write('<link rel="stylesheet" href="//cdn.jsdelivr.net/bootstrap/latest/css/bootstrap.min.css" />');
    documentToPrint.document.title = gridName;
    documentToPrint.document.write('<body onload="window.print();">');
    documentToPrint.document.write("<h1>" + gridName + "</h1>");
    documentToPrint.document.write(tableHtml);
    documentToPrint.document.write('</body>');
    documentToPrint.document.close();
}
function exportFile(gridResult, columns) {
    var csvFile = tubular_common_1.getCsv(gridResult, columns);
    var fileURL = URL.createObjectURL(new Blob(["\uFEFF" + csvFile], {
        type: 'text/csv;charset=utf-8;',
    }));
    var downloadLink = document.createElement('a');
    downloadLink.setAttribute('href', fileURL);
    downloadLink.setAttribute('id', 'download');
    downloadLink.setAttribute('download', 'data.csv');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    URL.revokeObjectURL(fileURL);
}
exports.exportGrid = function (media, gridResult, columns, gridName) {
    if (media === 'csv') {
        exportFile(gridResult, columns);
    }
    else {
        printDoc(gridResult, columns, gridName);
    }
};
